export default [
    {
        path: '/box/in-box',
        name: 'box_in_box',
        component: () => import('@src/box/in-box'),
        meta: {
            title: 'Einboxen',
            role: 'ROLE_IN_BOX',
        },
    },
    {
        path: '/box/overview',
        name: 'box_overview',
        component: () => import('@src/box/overview'),
        meta: {
            title: 'Boxübersicht',
            role: 'ROLE_LIST_BOX',
        },
    },
    {
        path: '/box/show/:id',
        name: 'box_show',
        component: () => import('@src/box/show'),
        meta: {
            title: 'Boxen anzeigen',
            role: 'ROLE_SHOW_BOX',
        },
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
    },
    {
        path: '/box/create',
        name: 'box_create',
        component: () => import('@src/box/create'),
        meta: {
            title: 'Boxen anlegen',
            role: 'ROLE_EDIT_BOX',
        },
    },
    {
        path: '/box/amount-one-bin-warehouse-reserved',
        name: 'amount_one_bin_warehouse_reserved_boxes',
        component: () => import('@src/box/amount-one-bin-warehouse-reserved-boxes'),
        meta: {
            title: 'Anzahl freizuhaltender Boxen',
            role: 'ROLE_BOX_SETTINGS',
        },
    },
];
